export default __webpack_public_path__ + "static/media/pci-icon.cc08e1eb.png";